export default __webpack_public_path__ + "static/sig-nav-0ad18b6723da981fb789d0f66fddfaca.png";